import script from "./APagar.vue?vue&type=script&setup=true&lang=js"
export * from "./APagar.vue?vue&type=script&setup=true&lang=js"

import "./APagar.vue?vue&type=style&index=0&id=1b5f925e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b5f925e"]])

export default __exports__